import { React } from "react";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import InputLabel from '@mui/material/InputLabel';

// arr of obj [{},{}]
const GCLgAutocomplete = ({
    options = [],
    xDisabled = false,
    xValue = [],
    handleChange,
    xtabIndex = "",
    xLabelText,
    icon,
    checkedIcon,
  }) => {
    return (
      <div
        className="GCLgAutocomplete"
        style={{ background: xDisabled ? "#e9ecef" : "transparent" }}
      >
        <Autocomplete
          tabIndex={xDisabled ? "" : xtabIndex}
          multiple
          options={options}
          className="GCLgAutocompleteInput"
          disableCloseOnSelect
          getOptionLabel={(option) => option?.Name1}
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option?.UId}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option?.Name1}
            </li>
          )}
          style={{
            width: "100%",
            maxHeight: 100, // Adjust the maximum height as needed
            overflow: "auto",
          }}
          renderInput={(params) => (
            <TextField
              {...params}
             // size="medium"
              label={xLabelText}
              placeholder=""
              
              sx={{
    "& .MuiInputLabel-root": {
      top: "2px",
      fontSize: "0.85rem",
    },
    "& .MuiAutocomplete-input": {
      padding: "2px 4px !important",
    },
  }}
              InputLabelProps={{ shrink: true }}
            />
          )}
          onChange={handleChange}
          value={ xValue}
          // paperprops={{
          //   style: {
          //     maxHeight: 200, // Adjust the maximum height as needed
          //     overflow: "auto",
          //   },
          // }}
          disabled={xDisabled}
        />
        {/* <button onClick={handleReset}>RefreshIcon</button> */}
      </div>
    );
  };
  export default GCLgAutocomplete;
